<template>
  <div class="modul">
    <div class="modul-top">
      <div class="caidan-img">
        <img src="../../../assets/image/caidan.png"
             alt="菜单">
      </div>
      <div class="caidan-title">
        菜单管理
      </div>
    </div>
    <el-row class="pTop">
      <el-form :inline="true"
               :model="formInline"
               style="text-align:left"
               class="demo-form-inline">
        <el-form-item>
          <el-button icon="el-icon-plus"
                     type="primary"
                     @click="add(0)">新增菜单</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button icon="el-icon-search"
                     :loading="loading"
                     type="primary"
                     @click="searchClick()">查询</el-button>
        </el-form-item> -->
      </el-form>
    </el-row>
    <div style="margin-top: 10px">
      <!-- style="width: 100%;margin-bottom: 20px;max-height:73vh; min-height: 73vh; height: 73vh;overflow: scroll;" -->
      <el-table :data="tableData"
                max-height="70vh"
                style="overflow-y: scroll;"
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                row-key="menuUuid"
                border
                v-loading="loading"
                :tree-props="{ children: 'childMenu', }">
        <!--  -->
        <el-table-column prop="menuName"
                         label="菜单/按钮名称">
        </el-table-column>
        <el-table-column width="150"
                         prop="menuType"
                         label="类型">
          <template slot-scope="scope">
            <div v-if="scope.row.menuType ==1">一级菜单</div>
            <div v-if="scope.row.menuType == 2">二级菜单</div>
            <div v-if="scope.row.menuType == 3">按钮</div>
            <!-- <div v-if="scope.row.menuType == 3">三级菜单</div> -->
            <!-- <div v-if="scope.row.menuType == 4">按钮</div> -->
          </template>
        </el-table-column>
        <el-table-column prop="route"
                         label="路由"> </el-table-column>
        <el-table-column prop="addr"
                         label="地址"> </el-table-column>
        <el-table-column prop="icon"
                         label="图标"> </el-table-column>
        <el-table-column width="80"
                         sortable
                         prop="sort"
                         label="排序"> </el-table-column>
        <el-table-column width="200"
                         label="操作">
          <template slot-scope="scope">
            <el-button type="text"
                       size="small"
                       @click="edit(scope.row)">编辑</el-button>

            <el-divider v-if="scope.row.menuType !== 4"
                        direction="vertical"></el-divider>
            <!-- <el-button v-if="scope.row.menuType !== 4"
                       type="text"
                       size="small"
                       @click="add( scope.row.menuType ,scope.row)">{{ scope.row.menuType == 1?"添加二级菜单":scope.row.menuType == 2?"添加三级菜单":'添加按钮' }}</el-button> -->
            <el-button v-if="scope.row.menuType !== 4"
                       type="text"
                       size="small"
                       @click="add( scope.row.menuType ,scope.row)">{{ scope.row.menuType == 1?"添加二级菜单":'添加按钮' }}</el-button>

            <el-divider direction="vertical"></el-divider>
            <el-button type="text"
                       size="small"
                       @click="Del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog :visible.sync="dialogFormVisible"
               :modal-append-to-body="false"
               :close-on-click-modal='false'
               width="35%">
      <div class="modul-top1"
           slot="title">
        <div class="caidan-img">
          <img src="../../../assets/image/caidan.png"
               alt="菜单">
        </div>
        <div class="caidan-title">
          {{title}}
        </div>
      </div>
      <el-form :model="form"
               label-width="80px"
               :rules="rules"
               ref='formName'>
        <el-form-item label="菜单名称">
          <el-input v-model="form.menuName"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="菜单类型">
          <div style="text-align:left">
            <el-select v-model="form.menuType"
                       disabled=""
                       placeholder="请选择菜单类型">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-form-item>

        <el-form-item label="路由">
          <el-input v-model="form.route"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="地址">
          <el-input v-model="form.addr"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="图标">
          <el-input v-model="form.icon"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序"
                      prop="sort">
          <el-input v-model.number="form.sort"
                    autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="submit()">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: 'ZuijiBridegCaidan',

  data () {
    return {
      formInline: {},
      loading: false,
      tableData: [],
      title: '',
      dialogFormVisible: false,
      rules: {
        sort: [{
          required: true,
          message: '请填写排序',
          trigger: 'blur'
        }]
      },
      form: {

      },
      options: [{
        value: 1,
        label: '一级菜单'
      }, {
        value: 2,
        label: '二级菜单'
      },
      {
        value: 3,
        label: '按钮'
      }
        // {
        //   value: 3,
        //   label: '三级菜单'
        // },
        //  {
        //   value: 4,
        //   label: '按钮'
        // }
      ],
      menuType: 1,

    };
  },
  async mounted () {
    this.searchClick();
  },
  beforeCreate: function () { },
  created: function () {

  },
  computed: {
    path () {
      return this.$route.path
    },
  },
  watch: {
    path (one, two) {
      this.searchClick();
    },
  },
  methods: {
    async searchClick () {
      this.loading = true;
      const res = await this.$api.sendPost("/menu/list", {});
      if (res.errcode == 0) {
        // console.log('caidan');
        this.tableData = res.data.voList;
        this.loading = false;
      } else {
        this.$message.warning(res.errmsg);
      }
      console.log(this.tableData);
    },
    add (menuType, row) {
      console.log(row)
      // this.title = menuType == 0 ? "添加一级菜单" : menuType == 1 ? "添加二级菜单" : menuType == 2 ? "添加三级菜单" : '添加按钮';
      this.title = menuType == 0 ? "添加一级菜单" : menuType == 1 ? "添加二级菜单" : '添加按钮';
      this.form = {
        parentUuid: row ? row.menuUuid : null,
        menuType: menuType + 1,
        sort: menuType == 0 ? this.tableData.length + 1 : row.childMenu.length + 1
      }
      this.dialogFormVisible = true;
    },
    edit (row) {
      this.title = '编辑';
      this.form = JSON.parse(JSON.stringify(row));
      this.dialogFormVisible = true;
    },
    submit () {
      this.$refs['formName'].validate(async (valid) => {
        if (valid) {
          const res = await this.$api.sendPost('/menu/insertOrUpdateMenu', this.form);
          if (res.errcode === 0) {
            this.$message.success(
              {
                message: res.errmsg,
                duration: 1000,
              });
            this.searchClick();
          } else {
            this.$message.warning(res.errmsg);
          }
          this.dialogFormVisible = false;
        } else {
          return false;
        }
      })
    },
    Del (row) {
      this.$confirm('是否删除此菜单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$api.sendGet('/menu/delete', { id: row.id });
        if (res.errcode == 0) {
          this.$message.success(res.errmsg);
          this.searchClick();
        } else {
          this.$message.warning(res.errmsg);
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.fieldData {
  border-bottom: 2px solid #4090f7;
  padding-left: 10px;
  padding-right: 10px;
  font-weight: bold;
  font-size: 14px;
  color: #4090f7;
}

.line1 {
  border-bottom: 1px solid #d8d8d8;
}

.myTitle {
  margin: 0;
  height: 20px;
  margin-top: 30px;
  margin-bottom: 30px;
  margin-left: 10px;
  font-weight: bold;
  font-size: 14px;
}
.margin30 {
  border: 0;
  background-color: #142850;
  height: 1px;
}
.el-table .warning-row {
  background: oldlace;
}
.el-table .info-row {
  background-color: #4090f7;
}
.el-table .success-row {
  background: #f0f9eb;
}
</style>